import { motion } from "framer-motion";

interface JusticeScaleIconProps {
  stroke: string;
  strokeWidth?: number;
  scale?: number;
  x?: number;
  y?: number;
  pathLength?: boolean;
  className?: string;
}

const JUSTICE_SCALE_PATH =
  "M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z";

const JusticeScaleIcon = ({
  stroke,
  strokeWidth = 2,
  scale = 0.65,
  x = -12,
  y = -12,
  pathLength = false,
  className = "pointer-events-none select-none",
}: JusticeScaleIconProps) => {
  const baseProps = {
    d: JUSTICE_SCALE_PATH,
    stroke,
    strokeWidth,
    strokeLinecap: "round" as const,
    strokeLinejoin: "round" as const,
    fill: "none",
    style: { transformOrigin: "center center" },
    className,
  };

  const animateProps = pathLength
    ? {
        pathLength: 1,
        opacity: 1,
        scale,
        x,
        y,
      }
    : {
        scale,
        opacity: 1,
        x,
        y,
      };

  const initialProps = pathLength
    ? {
        pathLength: 0,
        opacity: 0,
        scale: 0,
      }
    : {
        scale: 0.6,
        opacity: 0,
      };

  const exitProps = pathLength
    ? {
        pathLength: 0,
        opacity: 0,
        scale: 0,
      }
    : {
        scale: 0.6,
        opacity: 0,
      };

  return (
    <motion.path {...baseProps} initial={initialProps} animate={animateProps} exit={exitProps} />
  );
};

export default JusticeScaleIcon;
